import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=3c3ac201&scoped=true&"
import script from "./Parent.vue?vue&type=script&lang=js&"
export * from "./Parent.vue?vue&type=script&lang=js&"
import style0 from "./Parent.vue?vue&type=style&index=0&id=3c3ac201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ac201",
  null
  
)

export default component.exports